// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1IUw5","itemTitle":"ClientEmergencyInfo_itemTitle__V7tX_","itemText":"ClientEmergencyInfo_itemText__dUYqn"};